import React from "react";
import { svg } from "../../../../../Assets/svg";
import { Modal, Table } from "antd";
import { formatCurrency } from "../../../../../helpers/utils";

const ViewProfitDataModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: any;
  profitData: any;
}> = ({ visible, setIsModalVisible, onClose, profitData }) => {
  console.log(profitData, "calling profitData");

  const data = [
    {
      key: "product",
      type: "Product",
      estimated: profitData?.product_cost || 0,
      actual: profitData?.orignal_product_cost || 0,
      estimated_profit:
        (profitData?.product_cost || 0) -
        (profitData?.orignal_product_cost || 0),
      diff:
        (profitData?.product_cost || 0) -
        (profitData?.orignal_product_cost || 0),
    },
    {
      key: "bespoke_items",
      type: "Bespoke Items",
      estimated: profitData?.bespoke_cost || 0,
      actual: profitData?.orignal_bespoke_cost || 0,
      estimated_profit:
        (profitData?.bespoke_cost || 0) -
        (profitData?.orignal_bespoke_cost || 0),
      diff:
        (profitData?.bespoke_cost || 0) -
        (profitData?.orignal_bespoke_cost || 0),
    },
    {
      key: "mezzanine_floor",
      type: "Mezzanine Floor",
      estimated: profitData?.mezzanine_cost || 0,
      actual: profitData?.orignal_mezzanine_cost || 0,
      estimated_profit:
        (profitData?.mezzanine_cost || 0) -
        (profitData?.orignal_mezzanine_cost || 0),
      diff:
        (profitData?.mezzanine_cost || 0) -
        (profitData?.orignal_mezzanine_cost || 0),
    },
    {
      key: "services",
      type: "Services",
      estimated: profitData?.service_cost || 0,
      actual: profitData?.orignal_service_cost || 0,
      estimated_profit:
        (profitData?.service_cost || 0) -
        (profitData?.orignal_service_cost || 0),
      diff:
        (profitData?.service_cost || 0) -
        (profitData?.orignal_service_cost || 0),
    },
    {
      key: "installation",
      type: "Installation",
      estimated: profitData?.installation_cost || 0,
      actual: profitData?.orignal_installation_cost || 0,
      estimated_profit: 0,
      diff:
        (profitData?.installation_cost || 0) -
        (profitData?.orignal_installation_cost || 0),
    },
    {
      key: "delivery",
      type: "Delivery",
      estimated: profitData?.delivery_cost || 0,
      actual: profitData?.orignal_delivery_cost || 0,
      estimated_profit:
        (profitData?.delivery_cost || 0) -
        (profitData?.orignal_delivery_cost || 0),
      diff:
        (profitData?.delivery_cost || 0) -
        (profitData?.orignal_delivery_cost || 0),
    },
    {
      key: "plant_hire",
      type: "Plant Hire",
      estimated: profitData?.plant_hire_cost || 0,
      actual: profitData?.orignal_plant_hire_cost || 0,
      estimated_profit: 0,
      diff:
        (profitData?.plant_hire_cost || 0) -
        (profitData?.orignal_plant_hire_cost || 0),
    },
    {
      key: "sales_commission",
      type: "Sales Commission",
      estimated: 0,
      estimated_profit: -Math.abs(profitData?.sales_commission_amount || 0),
      actual: profitData?.sales_commission_amount || 0,
      diff: 0 - (profitData?.sales_commission_amount || 0),
    },
    {
      key: "vat",
      type: `VAT ${profitData?.vat_percentages ? `(${profitData?.vat_percentages}%)` : ""
        }`,
      estimated: profitData?.vat || 0,
      actual: profitData?.vat || 0,
      estimated_profit: 0,
      diff: 0,
    },
  ];

  const totalEstimated = data.reduce((sum, item) => sum + item.estimated, 0);
  const totalEstimatedProfit = data.reduce(
    (sum, item) => sum + item.estimated_profit,
    0,
  );
  const totalActual = data.reduce((sum, item) => sum + item.actual, 0);
  const totalDiff = totalEstimated - totalActual;

  const dataSource = [
    ...data,
    {
      key: "total",
      type: "Total",
      estimated: totalEstimated,
      actual: totalActual,
      estimated_profit: totalEstimatedProfit,
      diff: totalDiff,
      isTotal: true,
    },
  ];

  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 150,
      onCell: (record: any) =>
        record.isTotal
          ? { style: { background: "#eaeaea", borderTop: "2px solid #555" } }
          : {},
      render: (text: string, record: any) => (
        <span className={record.isTotal ? "fw-bold text-dark" : "fw-semibold"}>
          {text}
        </span>
      ),
    },
    {
      title: "Estimate Cost",
      dataIndex: "estimated",
      key: "estimated",
      width: 130,
      onCell: (record: any) =>
        record.isTotal
          ? { style: { background: "#eaeaea", borderTop: "2px solid #555" } }
          : {},
      render: (val: number, record: any) => {
        return (
          <span className={record.isTotal ? "fw-bold text-dark" : ""}>
            {formatCurrency(
              val,
              profitData?.currency,
              profitData?.conversion_rate,
            )}
          </span>
        );
      },
    },
    {
      title: "Actual Cost",
      dataIndex: "actual",
      key: "actual",
      width: 130,
      onCell: (record: any) =>
        record.isTotal
          ? { style: { background: "#eaeaea", borderTop: "2px solid #555" } }
          : {},
      render: (val: number, record: any) => (
        <span className={record.isTotal ? "fw-bold text-dark" : ""}>
          {profitData?.is_order_created
            ? formatCurrency(
              val,
              profitData?.currency,
              profitData?.conversion_rate,
            )
            : "-"}
        </span>
      ),
    },
    {
      title: "Estimated Profit",
      dataIndex: "estimated_profit",
      key: "estimated_profit",
      width: 130,
      onCell: (record: any) =>
        record.isTotal
          ? { style: { background: "#eaeaea", borderTop: "2px solid #555" } }
          : {},
      render: (val: number, record: any) => {
        const className =
          val == 0
            ? "fw-bold text-dark"
            : val > 0
              ? "text-success fw-semibold"
              : val < 0
                ? "text-danger fw-semibold"
                : "";
        const sign = val > 0 ? "+" : "";
        return (
          <span className={className}>
            {sign}
            {formatCurrency(
              val,
              profitData?.currency,
              profitData?.conversion_rate,
            )}
          </span>
        );
      },
    },
    {
      title: "Actual Profit",
      dataIndex: "diff",
      key: "diff",
      width: 130,
      onCell: (record: any) =>
        record.isTotal
          ? { style: { background: "#eaeaea", borderTop: "2px solid #555" } }
          : {},
      render: (val: number, record: any) => {
        if (!profitData?.is_order_created) {
          return <span>-</span>;
        }
        const className =
          val == 0
            ? "fw-bold text-dark"
            : val > 0
              ? "text-success fw-semibold"
              : val < 0
                ? "text-danger fw-semibold"
                : "";
        const sign = val > 0 ? "+" : "";
        return (
          <span className={className}>
            {sign}
            {formatCurrency(
              val,
              profitData?.currency,
              profitData?.conversion_rate,
            )}
          </span>
        );
      },
    },
  ];

  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m mb-4">
          {profitData?.display_quote_id
            ? `Quotation #${profitData?.display_quote_id}`
            : `Order #${profitData?.display_order_id}`}{" "}
          Profit Data
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"55rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
          >
            CLOSE
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        {!profitData?.is_order_created ? (
          <div className="mb-3">
            <p className="mb-0 pb-0 ">
              <span className="fw-semibold">Notes: </span>The actual profit
              calculation will be shown after the order is invoiced.
            </p>
          </div>
        ) : (
          ""
        )}
        <div className="card page-table-card border-0 shadow rounded-4 flex-fill overflow-y-auto">
          <div className="card-body overflow-y-auto">
            <Table
              dataSource={dataSource}
              columns={columns}
              scroll={{ x: "max-content" }}
              pagination={false}
              className="custom-table ordersTable cursor-pointer"
              bordered
              // size="middle"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewProfitDataModal;
